import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";

import type { HaNTextRange } from "@lib/logic";
import type { AreaResource } from "@lib/store";
import { ModalCellItemIcon } from "@molecules";

import { HaNSearchResultCell } from "./HaNSearchResultCell";

type AreaSearchResultProps = {
  area: AreaResource;
  ranges: HaNTextRange[];
};

export const AreaSearchResult = ({ area, ranges }: AreaSearchResultProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const details =
    area.data.workspaceBookingPolicyType === "DeskBooking"
      ? `${t("workplace:Desk", { count: area.data.capacity })}, ${area.floorName}`
      : area.floorName;

  return (
    <HaNSearchResultCell
      icon={
        <ModalCellItemIcon
          className="flex-none"
          backgroundColor={theme.card.beige500.background}
          icon="desk"
        />
      }
      name={area.name}
      ranges={ranges}
      details={details}
    />
  );
};
